/**
 * エラーコードの番号（3 桁）と発生箇所の対照表。docs/error-display-plan.md 付録 A / B の番号を使う。
 * ここが唯一の正で、docs/error-codes.md はここから生成する。
 * 番号は呼び出し箇所ごとに一意。欠番は再利用しない。
 *
 * feature: GA4 の feature パラメータと対照表にだけ使う（コードには含めない）
 */
export const errorSites = {
  "000": { feature: "GLOBAL", label: "未処理例外（グローバルハンドラ）", file: "src/main.js" },

  // HOME: トップ画面（ログイン後の最初の画面）
  "076": { feature: "HOME", label: "オプション情報の取得（optionManager.update）", file: "src/views/Home.vue" },
  "077": { feature: "HOME", label: "顧客別価格の取得（productPriceManager.update）", file: "src/views/Home.vue" },

  // AUTH: ログイン画面（072 / 073 は付録 A、089 / 090 は 2026-09-07 追加）
  "072": { feature: "AUTH", label: "ログイン後のユーザー情報登録（User.registInfo / PHP A02）", file: "src/views/Login.vue" },
  "073": { feature: "AUTH", label: "ログイン後のユーザー情報取得（User.getInfo / PHP A01）", file: "src/views/Login.vue" },
  "089": { feature: "AUTH", label: "Google / Apple のリダイレクトログイン結果の取得（getRedirectResult）", file: "src/views/Login.vue" },
  "090": { feature: "AUTH", label: "メール / パスワードのログイン（signInWithEmailAndPassword）", file: "src/views/Login.vue" },
};

export function getErrorSite(siteNo) {
  return errorSites[siteNo] || { feature: "UNKNOWN", label: "", file: "" };
}
